import { cva } from 'class-variance-authority';

export const cardVariants = cva('eye:relative eye:rounded-md', {
  variants: {
    variant: {
      // `highlight` declares no `--label-surface`: its background is a
      // gradient, which no single colour matches.
      default:
        'eye:bg-white eye:[--label-surface:var(--background-color-white)]',
      highlight: 'eye:bg-card-highlight',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
